import React from 'react';
import { PlayCircle, FileText } from 'lucide-react';
export function ResourcesSection() {
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-193">
      <div className="max-w-4xl mx-auto text-center bg-soft rounded-3xl p-10 md:p-16 shadow-lg border border-light/30 relative overflow-hidden" data-id="element-194">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-light/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-195"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-warm/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-196"></div>

        <div className="relative z-10" data-id="element-197">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white text-primary font-bold text-xs tracking-widest uppercase mb-6 shadow-sm" data-id="element-198">
            CADOUL MEU PENTRU TINE
          </span>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-10" data-id="element-199">
            Începe de acum, gratuit
          </h2>

          {/* Resource cards with integrated buttons */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-lg mx-auto" data-id="element-200">
            {/* Video Card */}
            <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col items-center text-center" data-id="element-201">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-medium flex items-center justify-center mb-4 shadow-lg" data-id="element-202">
                <PlayCircle size={32} className="text-white" data-id="element-203" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-204">
                Video-uri Săptămânale Cadou
              </h3>
              <p className="text-sm text-body leading-relaxed mb-5" data-id="element-205">
                Lecții video gratuite despre echilibrul trup-minte-suflet pe
                canalul meu
              </p>
              <a href="https://www.youtube.com/@drcorneliatianu/videos" className="mt-auto w-full rounded-full bg-primary text-white font-semibold px-6 py-3 hover:bg-[#5A1D5F] transition-colors shadow-md inline-block text-center text-sm" data-id="element-206">
                Către resurse video
              </a>
            </div>

            {/* WhatsApp Card */}
            <div className="bg-white rounded-2xl p-6 shadow-md flex flex-col items-center text-center" data-id="element-207">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-medium flex items-center justify-center mb-4 shadow-lg" data-id="element-208">
                <FileText size={32} className="text-white" data-id="element-209" />
              </div>
              <h3 className="text-lg font-bold text-dark mb-2" data-id="element-210">
                Comunitate WhatsApp
              </h3>
              <p className="text-sm text-body leading-relaxed mb-5" data-id="element-211">
                Vino în comunitatea de WhatsApp pentru suport și conexiune
              </p>
              <a href="https://chat.whatsapp.com/CKGpQdMfE9Y5j1eimB7FlH?mode=gi_t" className="mt-auto w-full rounded-full bg-primary text-white font-semibold px-6 py-3 hover:bg-[#5A1D5F] transition-colors shadow-md inline-block text-center text-sm" data-id="element-212">
                Intră în Comunitate
              </a>
            </div>
          </div>

          <p className="text-lg text-body leading-relaxed max-w-2xl mx-auto" data-id="element-213">
            Primești materiale practice, exerciții simple, ghidaje și invitații
            la training-uri live, ca să începi să lucrezi cu tine chiar de azi,
            fără să cumperi nimic.
          </p>
        </div>
      </div>
    </section>;
}